import Styled from "styled-components";
import {MdLocationOn} from 'react-icons/md'
export const Container = Styled.div`
padding-top: 125px;
margin: 6%;

.resume {
    color: ${props => props.theme.whitelabel?.text_primary_color};
    font-weight: 700;
}

.star {
    float: right;
}

.hotel-name {
    color: #050922;
    font-weight: 400;
    font-size: 17px;
}

.map {
    color: #696969;
    font-weight: 400;
    font-size: 12px;
    cursor: pointer;
    text-decoration: underline;
}

.label {
    color: #050922;
    font-size: 17px;
}

`;

export const LocationMap = Styled(MdLocationOn)`
color: #696969;
height: 20px;
width: 20px;
`

export const ButtonLocation = Styled.button`

background: none;
border: none;
color: #696969;
font-weight: 400;
font-size: 13px;
text-decoration-line: underline;
`

export const CheckIn = Styled.div`
margin-top: 20px;
display: flex;
justify-content: space-between;

.top{
    margin-top: 7px;
}

p{
    color: ${props => props.theme.whitelabel?.text_primary_color};
    font-weight: 400;
    font-size: 17px;
    display: flex;
    flex-direction: column;
    text-align: center;

    span{
        color: rgba(38, 50, 56, 0.5);
        font-weight: 400;
        font-size: 13px;
    }
    
    @media(max-width: 800px) {
        margin-right: 20px;
       
}
}
`;

export const Line = Styled.div`
    border-bottom: 1px solid #C6C6C5;
    margin: 25px 0 20px;
`

export const Resume = Styled.div`
color: #050922;
font-weight: 700;
font-size: 16px;
margin-bottom: 0;
`

export const Span = Styled.span`
 float: right; 
 color: #696969 !important;
 font-size: 13px;
`

export const Cupom = Styled.div`
background-color: #F0F0F0;
margin-top: 30px;
display: flex;
padding: 10px;
margin-bottom: 30px;

input{
    border: 0;
    background-color: #F0F0F0;
    border-bottom: 1px solid #C6C6C5;
    float: right;
    outline: none;
    width: 40%;
    margin-left: 20px;
}

label{
    color: #050922;
    font-size: 17px;
    font-weight: 700;
}
`

export const Points = Styled.div`
display: flex;
flex-direction: row;
align-items: center;
margin-top: 6px;
margin-bottom: 20px;

.dots {
  flex: 1;
  border-bottom: 1px dashed #818181;
  margin-right: 10px;
  margin-left: 10px;
}
`;

export const Title = Styled.div`
    color: #050922;
    font-weight: 400;
    font-size: 15px;
    margin-bottom: 0; 
`;

export const ValuePoints = Styled.div`
    color: #696969;
    font-size: 13px;
`;

export const Values = Styled.div`

display: flex;
flex-direction: row;
align-items: center;
padding-top: 20px;

.dots {
  flex: 1;
  border-bottom: 1px dashed #818181;
  margin-right: 10px;
  margin-left: 10px;
}

`;
